var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 64C302.3 64 288 78.3 288 96L288 328.6C268.9 339.7 256 360.3 256 384C256 419.3 284.7 448 320 448C355.3 448 384 419.3 384 384C384 360.3 371.1 339.6 352 328.6L352 96C352 78.3 337.7 64 320 64zM64 448L64 512C64 547.3 92.7 576 128 576L512 576C547.3 576 576 547.3 576 512L576 240C576 213.5 554.5 192 528 192L480 192C453.5 192 432 213.5 432 240L432 384C432 445.9 381.9 496 320 496C258.1 496 208 445.9 208 384L208 240C208 213.5 186.5 192 160 192L112 192C85.5 192 64 213.5 64 240L64 448z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHole);
export default __webpack_public_path__ + "static/media/hole.94cefd101f259c576dd773e6b6a7e2df.svg";
export { ForwardRef as ReactComponent };